/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  font-family: $font-family-base;
}

.#{$prefix}caption-copyright-wrapper {
  display: flex;
  flex-direction: row;
  padding: 48px;
  background-color: v(backgroundColor);
  box-sizing: border-box;

  // has to be set for width calculation if both caption and copyright are set.
  &.#{$prefix}caption-and-copyright {
    white-space: nowrap;
  }

  .#{$prefix}caption-content {
    padding-right: 20px;
    max-width: 75%;
    font-weight: $font-weight-medium;

    eon-ui-text {
      color: v(contentColor);
    }

    &.#{$prefix}no-copyright {
      max-width: 100%;
      padding-bottom: 0 !important;
    }
  }

  .#{$prefix}copyright-content {
    padding-left: 20px;
    border-left: 1px solid v(leftBorderColor);

    eon-ui-text {
      color: v(contentColor);
    }
  }

  @include for-size(desktop-or-smaller) {
    .#{$prefix}caption-content {
      padding-right: 16px;
    }

    .#{$prefix}copyright-content {
      padding-left: 16px;
    }
  }

  @include for-size(phone) {
    flex-direction: column;

    .#{$prefix}caption-content {
      padding-right: 0;
      max-width: 100%;
      padding-bottom: 8px;
    }

    .#{$prefix}copyright-content {
      border-left: none;
      padding-left: 0;
      max-width: 100%;
    }
  }

  &.#{$prefix}no-caption {
    justify-content: flex-end;

    .#{$prefix}copyright-content {
      border-left: none;
      max-width: 100%;
    }
  }

  &.#{$prefix}vertical {
    flex-direction: column;
    white-space: normal;

    .#{$prefix}caption-content {
      padding-right: 0;
      max-width: 100%;
      padding-bottom: 20px;

      @include for-size(desktop-or-smaller) {
        padding-bottom: 16px;
      }

      @include for-size(tablet-or-smaller) {
        padding-bottom: 8px;
      }
    }

    .#{$prefix}copyright-content {
      border-left: none;
      padding-left: 0;
      max-width: 100%;
    }
  }
}

:host(.container-breakpoint-1200) {
  .#{$prefix}caption-copyright-wrapper {
    padding: 40px;
  }
}

:host(.container-breakpoint-800) {
  .#{$prefix}caption-copyright-wrapper {
    padding: 32px;
  }
}

:host(.container-breakpoint-400) {
  .#{$prefix}caption-copyright-wrapper {
    padding: 24px;
  }
}
